import { render } from "./UserPage.vue?vue&type=template&id=e084d1fc"
import script from "./UserPage.vue?vue&type=script&lang=js"
export * from "./UserPage.vue?vue&type=script&lang=js"

import "./UserPage.vue?vue&type=style&index=0&id=e084d1fc&lang=css"

import exportComponent from "/Users/1M/Projects/SLE/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__